import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FetchedData, genFetchedData } from '../../redux/fetchedData';
import {
  RFilesBwListUpdate,
  UploadFilesBwListUpdatePayload,
} from './types';

export type BwListUpdateState = {
  isShowModal: boolean;
  uploadType: UploadFilesBwListUpdatePayload['type'];
  loadFiles: FetchedData<RFilesBwListUpdate>;
};
const initialState: BwListUpdateState = {
  isShowModal: false,
  uploadType: 'pretarget',
  loadFiles: genFetchedData<RFilesBwListUpdate>(null),
};

const bwListUpdate = createSlice({
  name: 'bwListUpdate',
  initialState,
  reducers: {
    isShowModalChangeBwListUpdate(
      state,
      action: PayloadAction<BwListUpdateState['isShowModal']>,
    ) {
      state.isShowModal = action.payload;
    },
    setUploadTypeBwListUpdate(
      state,
      action: PayloadAction<BwListUpdateState['uploadType']>,
    ) {
      state.uploadType = action.payload;
    },
    setBwListLoadFiles(
      state,
      action: PayloadAction<BwListUpdateState['loadFiles']>,
    ) {
      state.loadFiles = action.payload;
    },
    setCleanLoadList(state) {
      state.loadFiles = initialState.loadFiles;
      state.uploadType = initialState.uploadType;
    },
  },
});

export const UploadFilesBwListUpdate = createAction<UploadFilesBwListUpdatePayload>(
  'bwListUpdate/UploadFilesBwListUpdate',
);

export const {
  isShowModalChangeBwListUpdate,
  setUploadTypeBwListUpdate,
  setBwListLoadFiles,
  setCleanLoadList,
} = bwListUpdate.actions;
export const bwListUpdateReducer = bwListUpdate.reducer;
